import taskTemplatesListUrl from './taskTemplatesList.html';

class TaskTemplatesListCtrl {
  constructor(TaskTemplatesService) {
    'ngInject';

    Object.assign(this, { TaskTemplatesService });
  }

  get noSearchResults() {
    const { query, allTemplates, filteredTemplates } = this.TaskTemplatesService;
    return query && allTemplates.length && !filteredTemplates.length;
  }
}

export default {
  templateUrl: taskTemplatesListUrl,
  controller: TaskTemplatesListCtrl,
  controllerAs: 'ctrl',
  bindings: {
    templates: '<',
  },
};
